import { toast, TypeOptions,ToastOptions} from 'react-toastify';

export const showAlert = (message : React.ReactNode, type : TypeOptions = 'default', options : ToastOptions = {}) => {
  toast(message,{type:type, ...options})
}